import * as React from 'react';

import { ChatMessageMeta } from '../../../../components/ChatMessageMeta';
import { CHATBOT_ID } from '../../../../constants/chatbotId';
import { useMessageContext } from '../../../../utils/messageContext';
import { EOutcomingStatus } from '../../../../types/messages';
import { getStatusIcon } from '../../utils';

export const ChatMessageMetaContainer: React.FC = () => {
  const { message, chatId } = useMessageContext();
  const { status, created, isOutcoming, offers, isDeleted } = message;

  const isOfferMessage = offers && offers.length > 0;
  const isChatbotOfferMessage = chatId === CHATBOT_ID && isOfferMessage && !isOutcoming;

  const statusIcon = React.useMemo(
    () => (isOutcoming && status !== EOutcomingStatus.Failed && !isDeleted ? getStatusIcon(status) : null),
    [isOutcoming, status, isDeleted],
  );

  if (isChatbotOfferMessage) {
    return null;
  }

  return <ChatMessageMeta created={created} statusIcon={statusIcon} />;
};
